export const MOBILE_DRAWER_PREVIEW_HEIGHT = 177;
